import { PageRowSection, PageSection, ReferanceCard } from "../../components"
import { useTranslation } from "react-i18next"
import TransMsg from './transMessage'
import GraphImage from '../../../../assets/images/other/realize_01.png'
import VisionLossImage1 from '../../../../assets/images/svgs/currentChallenge/visionLoss_01.png'
import VisionLossImage2 from '../../../../assets/images/svgs/currentChallenge/visionLoss_02.png'
import ExpandingImage from '../../../../assets/images/other/expanding_01.png'
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../../assets/data/educationHub/referancesData"
import { useMediaQuery } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light"
import {Box} from "@mui/system";

const styles = {
    sectionCardStyle: {
        backgroundColor: "#fff",
        py: "0px",
        px: "0px",
        boxShadow: "none"
    },
    visionLossCard: {
        display: "flex",
        flexDirection: "column",
        alignItems: 'center'
    }
}
const CurrentChallenge = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(600))

    return (
        <Box>
            <PageRowSection
                title={t(TransMsg.MORE_THAN_YOU_REALIZE)}
                description={t(TransMsg.MORE_THAN_YOU_REALIZE_DESC)}
                containerBoxSx={{ gap: "10px" }}
                contentWrapperSx={{ maxWidth: isMobileX ? "none" : "526px" }}
                sectionWrapperSx={{ pt: "77px", pb: "78px" }}
                rowImageSource={GraphImage}
                rowImageSx={{ height: "auto", width: isMobileX ? "360px" : "529px", backgroundColor: "#F8F8F8", }}
            />
            <PageSection
                title={t(TransMsg.FEAR_OF_VISION_LOSS)}
                description={t(TransMsg.FEAR_OF_VISION_LOSS_DESC)}
                sectionCardSx={styles.sectionCardStyle}
                imageStyle={{ maxWidth: "709px", maxHeight: "371px", width: "100%" }}
                containerBoxSx={styles.visionLossCard}
                sectionImgUrl={VisionLossImage1} />
            <PageSection
                title={t(TransMsg.WHICH_LEADS_TO)}
                sectionWrapperSx={{ pt: "6px" }}
                sectionCardSx={styles.sectionCardStyle}
                imageStyle={{ maxWidth: "709px", maxHeight: "371px", width: "100%" }}
                sectionImgUrl={VisionLossImage2} />
            <PageRowSection
                title={t(TransMsg.EXPANDING_POPULATION)}
                description={t(TransMsg.EXPANDING_POPULATION_DESC)}
                containerBoxSx={{ gap: "41px" }}
                contentWrapperSx={{ flex: 2 }}
                sectionWrapperSx={{ pt: "77px", pb: "78px" }}
                rowImageSource={ExpandingImage}
                rowImageSx={{ width: "320px", height: "auto", maxWidth: "320px" }}
                titleSx={{ whiteSpace: "nowrap" }}
            />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
            />
        </Box>
    )
}

export default CurrentChallenge